import React, { useEffect } from 'react'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import * as id from '../common/AcountingId'
import { Box, Button, Typography } from '@mui/material'
import { Item } from '../../../common/snippets'
import { useState } from 'react'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import DetailedTable from './tableReport/DetailedTable'
import jsPDF from 'jspdf'
import moment from 'moment'
import autoTable from 'jspdf-autotable'
import { CSVLink } from 'react-csv'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import { focusElemnt, navigation3 } from '../../../common/helper'
const BTwoCRefundDetailed = (props) => {
    const { filterData, loginData, tableData, isPdfLoading, setIsPdfLoading } = props
    const [state, setState] = useState({
        generatePDF: false,
        load: false,
    })
    const [reportData, setReportData] = useState([])
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
    useEffect(() => {
        if (tableData.length) {
            let newData = tableData.map((obj) => ({ ...obj, isRowData: true }))
            setReportData(newData)
        } else {
            setReportData([{ isNoData: true, caption: 'No Records', colSpan: 13 }])
        }
    }, [tableData])
    const columnSummaryDefs = [
        { headerName: 'GSTN/UIN of Receipeint', exportHead: 'GSTN/UIN of Receipeint', field: 'ReceipeintGSTIN', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '150px', textAlign: 'left' } },
        { headerName: 'Invoice Number', exportHead: 'Invoice Number', field: 'InvoiceNumber', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
        { headerName: 'Invoice Date', exportHead: 'Invoice Date', field: 'Invoicedate', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
        { headerName: 'Note Type', exportHead: 'Note Type', field: 'NoteType', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
        { headerName: 'Invoice Value', exportHead: 'Invoice Value', field: 'InvoiceValue', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'right' } },
        { headerName: 'Place of Supply', exportHead: 'Place of Supply', field: 'PlaceofSupply', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
        { headerName: 'Reverse Charge', exportHead: 'Reverse Charge', field: 'ReverseCharge', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
        { headerName: 'Invoice Type', exportHead: 'Invoice Type', field: 'InvoiceType', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Rate', exportHead: 'Rate', field: 'Rate', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Taxable Value', exportHead: 'Taxable Value', field: 'TaxableValue', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '120px', textAlign: 'right' } },
        { headerName: 'IGST', exportHead: 'IGST', field: 'IGST', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'CGST', exportHead: 'CGST', field: 'CGST', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'SGST', exportHead: 'SGST', field: 'SGST', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
    ]
    const printReport = (isSave = false) => {
        setState({ ...state, load: true, generatePDF: true })
        setIsPdfLoading(true);
        jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
        jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
        const doc = new jsPDF({ orientation: 'l', format: [1514, 1070], unit: 'px', compress: true })
        doc.setProperties({
            title: `B2C Refund Detailed.pdf`,
            subject: 'B2C Refund Detailed Report',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system,B2C Refund Detailed',
            creator: 'MTLPL',
        })
        const HeaderColumns = filterData.includeBranches ?
            [
                { header: 'Report View', dataKey: 'reportViewName', xlCol: { dataType: 'string' } },
                { header: 'Report Type', dataKey: 'reportTypeName', xlCol: { dataType: 'string' } },
                { header: 'State', dataKey: 'state', xlCol: { dataType: 'string' } },
                { header: 'GSTIN', dataKey: 'GSTOpt', xlCol: { dataType: 'string' } },
                { header: 'Branches', dataKey: 'branch', xlCol: { dataType: 'string' } },
            ] : [
                { header: 'Report View', dataKey: 'reportViewName', xlCol: { dataType: 'string' } },
                { header: 'Report Type', dataKey: 'reportTypeName', xlCol: { dataType: 'string' } },
                { header: 'State', dataKey: 'state', xlCol: { dataType: 'string' } },
            ]

        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: HeaderColumns,
            body: [filterData],
            startY: 160,
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: 18,
                fontStyle: 'normal',
                font: "Roboto",
                lineWidth: 0.6,
            },
            columnStyles: filterData.includeBranches ? {
                0: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                1: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                2: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                3: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                4: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 195, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
            } :
                {
                    0: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                    1: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                    2: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                }
            ,
            didDrawPage: function (data) {
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(18).setFont('Roboto', 'bold')
                doc.text(`Date:${filterData.FromDate} To ${filterData.ToDate}`, data.settings.margin.left, 150)
                doc.text(`${filterData.includeBranches ? `Report:B2C Refund (Includes Branches Having GSTIN)` : 'Report:B2C Refund '}`, doc.internal.pageSize.width - data.settings.margin.left, 150, "right")

            },
            showHead: "firstPage",
        })
        var totalPagesExp = '{total_pages_count_string}'
        const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
            const doc = data.doc
            // Footer
            var pageSize = doc.internal.pageSize
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
            var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

            var str = 'Page : ' + doc.internal.getNumberOfPages()
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(16)
            doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
            doc.setFont('Roboto', 'bold')
            doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
            doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
        }
        let drawCell = function (data) {
            var rows = data.table.body
            if (data.row.section === 'head') {
                if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                    data.cell.styles.halign = "right";
                } else {
                    data.cell.styles.halign = "left";
                }
            }
            rows.map((val) => {
                if (val.raw.isNoData) {
                    val.cells[0].text = val.raw.caption.toString();
                    val.cells[0].colSpan = val.raw.colSpan;
                    val.cells[0].styles.halign = 'center'
                }
            })
        }
        let pdfColumns = columnSummaryDefs.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        })
        autoTable(doc, {
            margin: { top: 100, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: pdfColumns,
            tableLineWidth: 0.6,
            body: reportData,
            styles: {
                lineWidth: [0, 0.6, 0, 0.6]
            },
            columnStyles: {
                0: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 130, font: 'Roboto', fontStyle: "normal", valign: 'middle', minCellHeight: 36, cellPadding: 6, halign: 'left' },
                1: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 85, font: 'Roboto', fontStyle: "normal", valign: 'middle', minCellHeight: 36, cellPadding: 6, halign: 'left' },
                2: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 85, font: 'Roboto', fontStyle: "normal", valign: 'middle', minCellHeight: 36, cellPadding: 6, halign: 'left' },
                3: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 80, font: 'Roboto', fontStyle: "normal", valign: 'middle', minCellHeight: 36, cellPadding: 6, halign: 'left' },
                4: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 100, font: 'Roboto', fontStyle: "normal", valign: 'middle', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                5: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 125, font: 'Roboto', fontStyle: "normal", valign: 'middle', minCellHeight: 36, cellPadding: 6, halign: 'left' },
                6: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 100, font: 'Roboto', fontStyle: "normal", valign: 'middle', minCellHeight: 36, cellPadding: 6, halign: 'left' },
                7: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 90, font: 'Roboto', fontStyle: "normal", valign: 'middle', minCellHeight: 36, cellPadding: 6, halign: 'left' },
                8: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 80, font: 'Roboto', fontStyle: "normal", valign: 'middle', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                9: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 103, font: 'Roboto', fontStyle: "normal", valign: 'middle', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                10: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 90, font: 'Roboto', fontStyle: "normal", valign: 'middle', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                11: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 90, font: 'Roboto', fontStyle: "normal", valign: 'middle', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                12: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 90, font: 'Roboto', fontStyle: "normal", valign: 'middle', minCellHeight: 36, cellPadding: 6, halign: 'right' },
            },
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                cellPadding: 6,
                minCellHeight: 36,

                fontSize: 16,
                valign: 'middle',
                font: 'Roboto',
                fontStyle: 'normal',
            },
            didParseCell: (data) => {
                drawCell(data)
            },
            didDrawPage: function (data) {
                doc.setTextColor(40)
                doc.addImage('/images/logo-66.png', 'JPEG', 30, 30, 50, 50)
                doc.setFontSize(26).setFont("Roboto", 'bold')
                doc.setTextColor(16, 79, 162)
                doc.text('Cargo System | GST Return Report', 30 + 60, 60)
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(22).setFont("Roboto", 'bold')
                doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 60, "right")
                jsPdfHeaderFooter(data, loginData, totalPagesExp)
            },
        })
        doc.setFont('Roboto')
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        if (isSave) {
            doc.save(`B2C Refund Detailed ${currentDateTime}.pdf`)
        }
        setTimeout(() => {
            setState({ ...state, generatePDF: false, load: true })
            const pdfUrl = doc.output('bloburl')
            document.getElementById('output').data = pdfUrl
            // document.getElementById('output').data = doc.output('datauristring', 'B2C Refund Detailed.pdf')
            focusElemnt('backBtn')

        }, 2000)

    }
    const backToScreenView = () => {
        setIsPdfLoading(false)
        const data = document.getElementById('output')
        data.innerHTML = ''
    }
    return (
        <>
            <Box sx={{ ...sx.reportFlex, justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
                <Typography variant="h5" display="block" sx={{ fontWeight: 600, color: '#444' }}>
                    Report For: B2C Refund Detailed
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }} className="reportButtons">
                    {!isPdfLoading ?
                        <>
                            <Item sx={sx.itemsx} className="disabled-wrapper"
                                onKeyDown={(e) => {
                                    navigation3(e, "csvfileBtn", id.reportmainButton, () => { })
                                }}>
                                <ReactHtmlTableToExcel
                                    id="exportExcelBtn"
                                    className="receiveitemExcelBtn"
                                    table="BTwoCRefundDetailed"
                                    filename={`B2C Refund Detailed Report ${currentDateTime}`}
                                    sheet="tablexls"
                                    buttonText="Export to Excel"
                                />
                            </Item>
                            <Item sx={sx.itemsx} className="disabled-wrapper"
                                onKeyDown={(e) => {
                                    navigation3(e, "exportPdf", "exportExcelBtn", () => { document.getElementById("csvfileBtn").click() })
                                }}
                            >
                                <CSVLink filename='B2C Refund Detailed.csv' id={"csvfileBtn"} className="receiveitembtn exportCSVBtn" data={reportData} headers={columnSummaryDefs.map((val) => ({ label: val.exportHead, key: val.field }))}>
                                    Export As CSV
                                </CSVLink>
                            </Item>
                            <Item sx={sx.itemsx} className="disabled-wrapper">
                                <Button variant="outlined" sx={{ width: '100%' }} id={"exportPdf"} className="receiveitembtn"
                                    onKeyDown={(e) => {
                                        navigation3(e, "printBtn", "csvfileBtn", () => printReport(true))
                                    }}
                                    onClick={() => {
                                        printReport(true)
                                    }}>
                                    Export As PDF
                                </Button>
                            </Item>
                            <Item sx={sx.itemsx} className="disabled-wrapper">
                                <Button variant="outlined" id={"printBtn"} sx={{ width: '100%' }} className="receiveitembtn"
                                    onKeyDown={(e) => {
                                        navigation3(e, id.fromDate, "exportPdf", () => printReport())
                                    }}
                                    onClick={() => {
                                        printReport()
                                    }} >
                                    Print
                                </Button>
                            </Item>
                        </>
                        :
                        <Item sx={sx.itemsx} className="disabled-wrapper">
                            <Button variant="outlined" id={"backBtn"} sx={{ width: '100%' }} className="receiveitembtn"
                                onKeyDown={(e) => {
                                    navigation3(e, id.fromDate, id.reportmainButton, () => {
                                        backToScreenView()
                                        focusElemnt(id.reportmainButton)
                                    })
                                }}
                                onClick={backToScreenView}>
                                Back
                            </Button>
                        </Item>
                    }
                </Box>
            </Box>
            {!isPdfLoading ?
                <Box sx={sx.reportFlex}>
                    <DetailedTable columnSummaryDefs={columnSummaryDefs} reportData={reportData} id={"BTwoCRefundDetailed"} />
                </Box> :
                <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
                    {state.generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
                    {state.load ? (
                        <object
                            id="output"
                            type="application/pdf"
                            width="100%"
                            height="440"
                            title="MTLPL -Cargo System - LR Wise Detailed Status"
                            aria-label="MTLPL -Cargo System - LR Wise Detailed Status"
                        ></object>
                    ) : (
                        ''
                    )}
                </Box>
            }
        </>
    )
}

export default BTwoCRefundDetailed